import { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Select,
  Input,
  Button,
  Tooltip,
  message,
  Tag,
  Modal,
} from "antd";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_nms_noteproject_self,
  req_del_nms_noteproject,
} from "../../api";
import AddNotebooklmModal from "./add-notebooklm-modal";

class MyNotebooklmList extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    items: [],
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    isAddModal: false,
    isEditModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_list_items();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    try {
      const result = await req_list_nms_noteproject_self(
        userLevel,
        userCode,
        "",
        "",
        userCode,
        "NONE",
        token
      );
      if (result.total > 0) {
        const items = result.data;
        this.setState({ items, loading: false });

        console.log(items);
      } else {
        const items = [];

        this.setState({ items, loading: false });
      }
    } catch (error) {
      message.error("網路連線不穩定，請稍後再試");
      this.setState({ loading: false });
    }
  };

  api_del_item = async (item) => {
    const { token} = this.props.user;
    try {
      await req_del_nms_noteproject(item.Uid, token);
      message.success("刪除成功");
      this.api_list_items();
    } catch (error) {
      message.error("刪除失敗");
    }
  };

  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: 40,
        dataIndex: "LmUrl",
        align: "center",
        render: (field, record) => {
          return (
            <>
              <div>
                <a
                  href={field}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  <i className="fas fa-book"></i> 瀏覽
                </a>
              </div>
              <Button
                type="danger"
                size="small"
                onClick={() => this.handle_show_ui_modal("DEL", record)}
                style={{ marginTop: "4px" }}
              >
                <i className="fas fa-minus" style={{ marginRight: "4px" }}></i> 
                刪除
              </Button>
            </>
          );
        },
      },
      {
        title: "分類",
        responsive: ["md"],
        width: 40,
        dataIndex: "NoteTypeName",
        align: "center",
        render: (field) => {
          return (
            <div>
              <Tag color={this.style_switch_color_tag("TYPE_COURSE", field)}>
                {field}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "筆記名稱",
        dataIndex: "NoteTitle",
        width: 80,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "筆記說明",
        responsive: ["md"],
        dataIndex: "NoteDescription",
        width: 100,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.2em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "適用對象",
        responsive: ["md"],
        dataIndex: "ApplicableDeparts",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "筆記作者",
        responsive: ["md"],
        dataIndex: "AuthorName",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "ADD":
        this.setState({ isAddModal: true, item });
        break;
      case "EDIT":
        this.setState({ isEditModal: true, item });
        break;
      case "DEL":
        Modal.confirm({
          title: "刪除確認",
          content: `您確定要刪除筆記 [${item.NoteTitle}] 嗎？`,
          okText: "確定",
          cancelText: "取消",
          onOk: () => {
            this.api_del_item(item);
          },
        });
        break;
      default:
    }
  };

  handle_close_ui_modal = (modal) => {
    switch (modal) {
      case "ADD":
        this.setState({ isAddModal: false });
        break;
      case "EDIT":
        this.setState({ isEditModal: false });
        break;
      default:
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "TYPE_COURSE":
        switch (param) {
          case "文件彙整":
            return "#e1a517ff";
          case "課程講義":
            return "#34495e";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  render() {
    const { items, loading, searchField, searchValue, isAddModal } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="NoteTitle">筆記名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <p></p>
      </>
    );
    const btn = (
      <>
        <Button type="primary" onClick={() => this.api_list_items()}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("ADD", {})}
        >
          <i className="fa fa-plus"></i>
          <span style={{ marginLeft: "4px" }}> 新增</span>
        </Button>{" "}
        <p></p>
      </>
    );
    return (
      <>
        {title}
        {btn}
        <Card bordered={false}>
          <Table
            dataSource={items}
            columns={this.columns}
            loading={loading}
            rowKey="uid"
            pagination={false}
          />
        </Card>

        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={500}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AddNotebooklmModal />
        </Modal>
      </>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(MyNotebooklmList);
